import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=21a2b8b7&"
import script from "./InformationModal.vue?vue&type=script&lang=ts&"
export * from "./InformationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports